import { atom, useAtomValue, useSetAtom } from 'jotai';

const cacheKey = '@fett/notificationSound';

type NotificationSound =
  | 'sound1'
  | 'sound2'
  | 'sound3'
  | 'sound4'
  | 'sound5'
  | 'sound6'
  | 'sound7'
  | 'sound8'
  | 'sound9'
  | 'sound10';

const notificationSoundAtom = atom<NotificationSound>(
  (localStorage.getItem(cacheKey) as NotificationSound) || 'sound1',
);
const notificationSoundState = atom(
  (get) => get(notificationSoundAtom),
  (_, set, val: NotificationSound) => {
    set(notificationSoundAtom, val);
    localStorage.setItem(cacheKey, val);
  },
);

export const useNotificationSound = () => useAtomValue(notificationSoundState);

export const useSetNotificationSound = () => useSetAtom(notificationSoundState);
